import { useCallback, useEffect, useState } from "react";
import { useDropzone } from "react-dropzone";
import EditUpload from "./EditUpload";
import ChangeColors from "./ChangeColors";
import { toast } from "react-toastify";
import UploadedImage from "./RecentUploads/intdex";
import Cookies from "js-cookie";
import {
  useAppDispatch,
  useAppSelector,
} from "../../../../../hooks/reduxHooks";
import { APP_CONSTANTS } from "../../../../../constants/AppConstants";
import { addImage } from "../../../../store/slices/viewSlice";
import Loader from "../../Loader";
import Popup from "../../Popup";
import FileUploads from "./FileUploads";
import { checkAndCreateSessionIdFromCookie } from "../../../../../utils/utils";
import { useSearchParams } from "react-router-dom";

const UploadDesign = () => {
  const dispatch = useAppDispatch();

  const win: any = window;
  const selectedViewId = useAppSelector(
    (state: any) => state.canvases.selectedViewId
  );
  const selectedObject = useAppSelector(
    (state: any) => state.canvases.selectedObject
  );

  const canvas: any = win["design_canvas"][selectedViewId];
  let object = canvas.getActiveObject();

  const [currentFile, setCurrentFile] = useState(object);
  const [changeColors, setChangeColors] = useState(false);
  let list = [];
  let localStorageImage = localStorage.getItem("user-uploaded-image");
  if (localStorageImage && localStorageImage !== "") {
    list = JSON.parse(localStorage.getItem("user-uploaded-image") as any);
  }

  const [uploadedImageList, setUploadedImageList] = useState(list);
  const [loading, setLoading] = useState(false);
  const [sessionId, setSessionId] = useState("id" + new Date().getTime());
  const [show, setShow] = useState(false);
    const [searchParams] = useSearchParams();
  const userId = searchParams.get("userId");
  const guest = searchParams.get("guest");
  const allowedFileSize = 5000000;
  const allowedFiles = [
    "image/png",
    "application/pdf",
    "image/jpeg",
    "image/svg+xml",
    "image/tiff",
    "image/gif",
    "image/bmp",
    "application/postscript",
    "application/postscript",
  ];

  useEffect(() => {
    const uniqueId: any = userId ? userId : checkAndCreateSessionIdFromCookie();
    setSessionId(uniqueId);
    const incrementedCount =
      parseInt(Cookies.get("User_Session_Count") as any) + 1;
    Cookies.set("User_Session_Count", incrementedCount.toString());
  }, []);

  const onDrop = useCallback((acceptedFiles: any) => {
    // setCurrentFile(acceptedFiles);
    uploadFile(acceptedFiles);
  }, []);

  const { getRootProps, getInputProps, isDragReject } = useDropzone({
    onDrop,
    accept: {
      "image/png": [".png", ".PNG"],
      "image/jpeg": [".jpg", ".jpeg", ".JPG", ".JPEG"],
      // "image/svg+xml": [".svg", ".SVG"],
      // "image/tiff": [".tiff", ".TIFF"],
      "image/gif": [".gif", ".GIF"],
    },
  });

  const handleReset = () => {
    setCurrentFile(null);
    // dispatch(startOver(""));
  };

  const handleChangeColors = () => {
    setChangeColors((prev) => !prev);
  };

  const updateUploadImage = (uploadedImage: any) => {
    let list = [];
    let localStorageImage = localStorage.getItem("user-uploaded-image");
    if (localStorageImage && localStorageImage !== "") {
      list = JSON.parse(localStorage.getItem("user-uploaded-image") as any);
    }

    list.push(uploadedImage);
    localStorage.setItem("user-uploaded-image", JSON.stringify(list));
    setUploadedImageList(list);
  };

  const uploadFile = (event: any) => {
    let receivedFileType = event[0].type;
    let receivedFileSize = event[0].size;

    if (
      allowedFiles.indexOf(receivedFileType) === -1 ||
      parseInt(receivedFileSize) > allowedFileSize
    ) {
      toast.error("Error wile uploading image, max size allowed size is 5MB");
      setShow(true);
      return;
    }
    // const allowedFileTypes = ["image/png", "image/jpeg"];
    // if (!allowedFileTypes.includes(receivedFileType)) {
    //   toast.error("Invalid file type. Only PNG and JPG files are allowed.");
    //   return;
    // }

    let formData = new FormData();
    formData.append("img", event[0]);
    formData.append("ecom_id", userId ? userId : sessionId);
    //self.ui.showUploadUploading();
    setLoading(true);
    fetch(APP_CONSTANTS.base_url + APP_CONSTANTS.uploadImage, {
      method: "POST",
      body: formData,
    })
      .then((response) => response.json())
      .then(
        (data) => {
          console.log(data);
          setLoading(false);
          updateUploadImage(data);

          // updateUploadImage({
          //   unique_id: data.id,
          //   session_id: sessionId,
          //   img: data.imageUrl,
          //   cfUpload_Image_Path: data.cfUpload_Image_Path,
          //   // "height": data.cfUpload_Image_Path.height,
          //   // width: data.load_image.width
          // });
          dispatch(
            addImage({
              img: data.imageUrl,
              width: data.width,
              height: data.height,
            })
          );
          // self.editorMediator.addOrUpdateImage(imageURL, { unique_id: data.cfUpload_Image_Path.unique_img_id, org_upload_src: data.cfUpload_Image_Path.original_img, des_upload_src: data.cfUpload_Image_Path.designer_img }, function() {
          //     self.ui.showUploadControls();
          // })
        },
        (err) => {
          setShow(true);
          setLoading(false);
          //  dispatch(addImage("https://placehold.co/600x400/EEE/31343C"));
          toast.error("Error in uploading image");
          // self.ui.showUploadContainer();
        }
      );
  };

  if (selectedObject && selectedObject.type === "image" && !changeColors)
    return (
      <EditUpload
        handleReset={handleReset}
        handleChangeColors={handleChangeColors}
      />
    );

  if (currentFile && changeColors)
    return <ChangeColors handleChangeColors={handleChangeColors} />;

  return (
    <>
      {loading ? (
        <Loader></Loader>
      ) : (
        <>
          <div className="font-bold text-2xl tracking-wide border-b border-solid border-lightgrey">
            Choose a File to Upload
          </div>
          <div className="border-b border-solid border-lightgrey py-4 mb-4">
            <div
              className="border-2 border-dashed border-primaryred p-6 cursor-pointer rounded-sm"
              {...getRootProps()}
            >
              <input {...getInputProps()} />
              <div className="flex justify-center items-center gap-4">
                <svg
                  width="64"
                  height="64"
                  viewBox="0 0 64 64"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M31.8193 40.7347H32.1805L31.9999 40.5706L31.8193 40.7347Z"
                    fill="black"
                  />
                  <path
                    d="M45.8246 26.122H45.25V25.2518C45.2478 22.8516 44.4226 20.5246 42.9121 18.6592C41.4016 16.7939 39.2972 15.5028 36.9499 15.0014C34.6025 14.5001 32.1543 14.8188 30.0135 15.9043C27.8728 16.9899 26.169 18.7766 25.1864 20.9665C24.3228 20.5806 23.383 20.3955 22.4376 20.4252C21.4922 20.4549 20.5659 20.6986 19.7283 21.1379C18.8906 21.5773 18.1635 22.2009 17.6017 22.9618C17.0398 23.7227 16.6579 24.6011 16.4845 25.5309C14.6939 26.0405 13.1473 27.179 12.1286 28.7373C11.1099 30.2955 10.6876 32.169 10.9391 34.0136C11.1906 35.8582 12.0992 37.5502 13.4979 38.7788C14.8966 40.0074 16.6916 40.6902 18.5532 40.7018H24.7102L24.8087 40.5704L29.5537 36.0225C30.1904 35.4075 31.041 35.0638 31.9262 35.0638C32.8114 35.0638 33.662 35.4075 34.2987 36.0225L39.0602 40.6033L39.1587 40.7346H45.7261C47.6639 40.7477 49.5275 39.9904 50.9069 38.6295C52.2863 37.2685 53.0686 35.4153 53.0817 33.4776C53.0948 31.5398 52.3375 29.6762 50.9766 28.2968C49.6156 26.9174 47.7624 26.1351 45.8246 26.122Z"
                    fill="black"
                  />
                  <path
                    d="M37.4181 42.3767L32.6731 37.763C32.4953 37.5895 32.2567 37.4924 32.0082 37.4924C31.7597 37.4924 31.5211 37.5895 31.3432 37.763L26.5818 42.3439C26.4429 42.4761 26.3472 42.6471 26.3071 42.8346C26.2671 43.0222 26.2846 43.2174 26.3573 43.3948C26.4301 43.5723 26.5547 43.7236 26.7148 43.829C26.875 43.9344 27.0633 43.9891 27.255 43.9857H29.6685V49.2561H34.3643V44.035H36.7778C36.9703 44.0352 37.1583 43.9772 37.3172 43.8684C37.476 43.7596 37.5981 43.6053 37.6674 43.4257C37.7368 43.2462 37.7501 43.0498 37.7056 42.8625C37.6611 42.6753 37.5609 42.5059 37.4181 42.3767Z"
                    fill="black"
                  />
                </svg>

                <div>
                  Drag & Drop or <br />
                  <span className="text-primaryred">Browse</span> Your Computer
                </div>
              </div>
            </div>
          </div>
          <div className="text-sm mb-6">
            Accepted File Types (Max size: 5 MB)
          </div>
          {/* Invalid File Type
           */}
          <div>
            {isDragReject && (
              <div className="text-red-500">
                Invalid file type. Please upload a valid file type.
              </div>
            )}
          </div>

          <div className="flex flex-wrap text-[9px] my-3">
            <div className="border border-solid border-lightgrey py-[2px] px-2">
              .JPG
            </div>
            <div className="border border-solid border-lightgrey ml-[-1px] py-[2px] px-2">
              .JPEG
            </div>
            <div className="border border-solid border-lightgrey ml-[-1px] py-[2px] px-2">
              .PNG
            </div>
            {/* <div className="border border-solid border-lightgrey ml-[-1px] py-[2px] px-2">
              .GIF
            </div>
            <div className="border border-solid border-lightgrey ml-[-1px] py-[2px] px-2">
              .BMP
            </div>
            <div className="border border-solid border-lightgrey ml-[-1px] py-[2px] px-2">
              .PDF
            </div>
            <div className="border border-solid border-lightgrey ml-[-1px] py-[2px] px-2">
              .AI
            </div>
            <div className="border border-solid border-lightgrey ml-[-1px] py-[2px] px-2">
              .PSD
            </div>
            <div className="border border-solid border-lightgrey ml-[-1px] py-[2px] px-2">
              .EPS
            </div> */}
          </div>
          {/* <div className="text-sm my-5">
            Have a different type of file?{" "}
            <a href="mailto:" className="text-primaryred">
              Email it to us
            </a>
            <br />
            and weʼll have it ready for you to use within a few hours!
          </div> */}
          <UploadedImage imageList={uploadedImageList}></UploadedImage>
          {/* <FileUploads /> */}
        </>
      )}
      <Popup show={show} setShow={setShow} title="Error!">
        <div className="upload-error p-5 text-center">
          <div className="justify-content-center">
            <h4 className="upload-error-title">
              <span>
                <span>Oops!</span>{" "}
                <span>
                  Your file is an unsupported file type or error in uploading.
                </span>
              </span>
            </h4>
            <p>
              Accepted file types (max size: 5 MB): .JPG .JPEG .PNG .GIF .BMP
              .PDF .AI .PSD .EPS
            </p>
            <p>
              Have a different type of file? <a href="#/help">Email it to us</a>{" "}
              and we'll have it ready for you to use within a few hours!{" "}
            </p>
          </div>
          <div className="modal-footer d-flex justify-content-center">
            <button
              onClick={() => {
                setShow(false);
              }}
              type="button"
              className="border-2 border-blue-500 bg-white text-black font-semibold py-2 px-4 min-w-[200px] rounded"
              data-dismiss="modal"
            >
              Close
            </button>
          </div>
        </div>
      </Popup>
    </>
  );
};

export default UploadDesign;
